package pwgs.ui.scenes.custompropertieseditorscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class ACustomPropertiesEditorControllerFe(props: pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneProps, scene: MCustomPropertiesEditorScene)
 : AController<pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneProps, pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel, CustomPropertiesEditorSceneState>(props, scene) {

    val backend = CustomPropertiesEditorControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_create() {
        launchOnDefaultControllerScope {
            render(backend.create())
        }
    }

    fun call_delete(propertyName: kotlin.String) {
        launchOnDefaultControllerScope {
            render(backend.delete(propertyName))
        }
    }

    fun call_update() {
        launchOnDefaultControllerScope {
            render(backend.update())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class CustomPropertiesEditorControllerBeProxy(private val controller: ACustomPropertiesEditorControllerFe) {

    suspend fun load(): pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel.serializer())
        }
    }

    suspend fun create(): pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorControllerBe.create",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel.serializer())
        }
    }

    suspend fun delete(propertyName: kotlin.String): pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel {
        @Serializable
        class ParamsWrapper(val propertyName: kotlin.String)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(propertyName))
        val p = RmiParams(
            action = "pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorControllerBe.delete",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel.serializer())
        }
    }

    suspend fun update(): pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorControllerBe.update",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.custompropertieseditorscene.CustomPropertiesEditorSceneModel.serializer())
        }
    }

}
